import { roundValue } from '../../../utils/math';
/**
 *
 * @param results
 * @returns
 */
export const calculateTsa = (results: Array<{ zscore: number }>): number => {
  // Calculates the values for reporting the TSA
  let totalZscore = 0;
  let validScores = 0;
  for (const result of results) {
    if (isFinite(result.zscore)) {
      totalZscore += result.zscore;
      validScores++;
    }
  }
  if (validScores > 0) {
    return roundValue(totalZscore / validScores, 1);
  }
};
